<template>


  <div class="card card-with-shadow border-0 h-100 employee-preview-card">
    <div class="card-body position-relative d-flex flex-column justify-content-between">
      <div v-if="showAction" class="dropdown options-dropdown position-absolute" style="z-index: 999">
        <button
          v-if="data.status == 'pending' || data.status == 'rejected'"
          type="button"
          class="btn-option btn d-flex align-items-center justify-content-center"
          data-toggle="dropdown"
        >
          <app-icon name="more-horizontal" />
        </button>
        <div class="dropdown-menu dropdown-menu-right py-2 mt-1" v-for="(action, index) in actions">
          <a class="dropdown-item px-4 py-2" href="#" :key="index"
            @click.prevent="callAction(action)">{{ action.title }}</a>

        </div>
      </div>
      <div class="d-flex flex-column">
        <!-- <app-avatar
          :title="data.name"
          avatar-class="avatars-w-60 mb-2 d-inline-block"
          :img="getImageUrl(data)"
        /> -->

        <h6 class="mb-3 mt-3">
         By: {{ fullName }} <small>{{companyName}}</small>
        </h6>
        <small>Email: {{email}}</small>
        <hr>
        <p class="mb-3 mt-3">
            Last Updated: {{ submittedAt }}
        </p>

        <div class="d-flex justify-content-end">
          <a href="#" @click.prevent="view(updatedData)">View Response</a>
        </div>

        <div class="d-flex justify-content-end">
          <a href="#" @click.prevent="counterSign(updatedData)">Counter Sign</a>
        </div>
         <div class="d-flex justify-content-end ">
                  <a href="#" class="text-danger" @click.prevent="deleteResponse(updatedData)">Delete Response</a>
         </div>

        <div class="d-flex justify-content-end" v-if="showChangeDateForm">
          <a href="#" @click.prevent="update()">Update Date</a>
        </div>

        <div v-if="changeDate">
          <app-input type="date"
                     class="col-12"
                     v-model="inputs.submittedAt"
                     :placeholder="$t('select_valid_date')"/>
        <a href="#" class="btn btn-sm btn-primary" @click.prevent="updateDate">
          {{ $t('update') }}
        </a>
          </div>



      </div>
    </div>
    <job-bid-detailmodal
        :title="responseModalTitle"
        v-if="isBidDetailModalActive"
        :data="data"
        @close-modal="closeBidDetailModal"
    />
    <task-endorse
        v-if="isTaskEndorseModalActive"
        modal-id="endorse-Modal"
        :taskId="taskId"
        :formData="updatedData"
        @close-modal="isTaskEndorseModalActive = false"
    />
  </div>



</template>

<script>

import AppFunction from "@/core/helpers/app/AppFunction";
import {formatDateToLocal, onlyTime} from "@/app/Helpers/Helpers";
import {mapState} from "vuex";
import {axiosPost} from "@/app/Helpers/AxiosHelper";
import {RESPONSE_DATE_UPDATE, RESPONSE_DELETE, STORE_COMMENTS} from "@/app/Config/ApiUrl";
import {FormMixin} from "@/core/mixins/form/FormMixin";

export default {
  name: 'ResponseGridCard',
  props: {
    data: {
      type: Object,
      required: true
    },
    actions: {
      type: Array,
      required: true
    },
    showAction: {
      type: Boolean,
      default: true
    },
    id: {
      required: true
    }
  },
  mixins: [FormMixin],
  data(){
    return{
      changeDate: false,
      isTaskEndorseModalActive: false,
      open : false,
      taskId : '',
      isBidDetailModalActive: false,
      responseModalTitle : 'Form Response',
      inputs: {},

      showChangeDateForm: this.$store.state.user.loggedInUser?.update_info === 1
    }
  },
  created(){
      debugger
  },
  methods: {
    update(){
      this.changeDate = !this.changeDate;
    },
    deleteResponse(data) {
      // Display a confirmation dialog
      const isConfirmed = window.confirm('Are you sure you want to delete this response?');

      // If the user confirms, proceed with the deletion
      if (isConfirmed) {
        axiosPost(RESPONSE_DELETE, data)
            .then((res) => {
              this.$toastr.s(res.data.message);
            })
            .catch((error) => {
              this.$toastr.e(error.response.data.message ?? error.message);
            })
            .finally(() => {
              // Additional cleanup or logic after deletion
              this.$hub.$emit('reload-grid-view-table');
            });
      }
      // If the user cancels, do nothing or handle accordingly
    },

    updateDate(){

      let inputRequest  = {submitted_at: this.inputs.submittedAt,
      responseData: this.data,
      }
      axiosPost(RESPONSE_DATE_UPDATE, inputRequest,)
          .then((res) => {
            this.$toastr.s(res.data.message);
            this.updatedData.responseData.updated_at = this.inputs.submittedAt
          })
          .catch((error) => {
            this.$toastr.e(error.response.data.message ?? error.message);
          }).finally(() => {
            this.update()
           });
    },
    view(data) {
      this.data = data;
      this.$store.commit('updateSharedData', {index: "guestFormData", newValue: data})

      this.isBidDetailModalActive = true;
    },  
    closeBidDetailModal() {
      this.isBidDetailModalActive = false;
      $("#bid-detail-show").modal("hide");
    },
    callAction(action) {
      this.$emit("action-" + this.id, this.data, action, true);
      // let id = this.data.id;
    },
    getImageUrl(data) {
      if (data.data_picture) {
        return AppFunction.getAppUrl(data.data_picture);
      }
      return AppFunction.getAppUrl('images/avatar-demo.jpg');
    },
    statusClass(status) {
      let ClassName = 'danger';
      if (status === 'accepted') ClassName = `success`;
      else if (status === 'pending') ClassName = `warning`;
      return ClassName;
    },
    closeModal() {
      this.JobModalActive = false;
    },

    counterSign(updatedData){
      this.taskId = updatedData.task_id
      this.isTaskEndorseModalActive = true;

    },

  },
  mounted() {
    // this.data.form_revision.get_bodies.body = JSON.parse(this.data.form_revision.get_bodies.body); 
    
  },
  // watch: {
  //   data: function (newVal , oldVal) {
  //      this.data.form_revision.get_bodies.body = JSON.parse(this.data.form_revision.get_bodies.body); 
  //   },
  // },
  computed: {
    ...mapState['sharedData'],
    updatedData()
    {
      return this.data;
    },
    fullName(){
       let isGuest = this.updatedData.guest;
       if (isGuest){
         return this.updatedData.guest_user.name
       }else{
         return this.updatedData.user.full_name
       }
       },
    email(){
      let isGuest = this.updatedData.guest;
      if (isGuest){
        return this.updatedData.guest_user.email
      }else{
        return this.updatedData.user.email
      }
    },
    companyName(){
      let isGuest = this.updatedData.guest;
      if (isGuest){
        return '(' + this.updatedData.guest_user.company_name +'*' + ')'
      } else {
        return '(' +this.updatedData.user.company?.company_name + ')'
      }
    },
    submittedAt(){
      let updatedAt = this.updatedData?.updated_at;
      return formatDateToLocal(updatedAt)+' '+onlyTime(updatedAt)

    },
},

}
</script>
<style>

.cardNewStyle {
  border: 0.5px solid #898989 !important;
}

</style>
